// @flow

import { type PathMatcher } from '@chatchamp/chatchamp-types'

import { checkUrl } from './checkUrl'

type UrlMatchSettings = {
  regex: string,
  pathMatcher: PathMatcher
}

export function isUrlMatching (urlMatchSettings: UrlMatchSettings, url: string, applyToSearchQuery: boolean = true): boolean {
  const matcherFunctions = {
    regex: () => checkUrl(urlMatchSettings.regex, url, applyToSearchQuery),
    contains: () => containsInPath(urlMatchSettings.regex, url, applyToSearchQuery),
    doesNotContain: () => !containsInPath(urlMatchSettings.regex, url, applyToSearchQuery)
  }

  const matcherFunction = matcherFunctions[urlMatchSettings.pathMatcher || 'regex']
  if (!matcherFunction) return false

  return matcherFunction()
}

function containsInPath (value: string, url: string, applyToSearchQuery: boolean): boolean {
  const { pathname, search } = new URL(url)

  return pathname.includes(value) || (applyToSearchQuery && search.includes(value))
}
